import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootState, useAppDispatch, useAppSelector } from '../store';
import { openApiService } from '../Services/openApiService';
import toast from 'react-hot-toast';
import { PaginationListType } from '../Types/PaginationParams';
import { setListReloadType } from '../Store/features/environment/environmentSlice';
import { OpenApiConfig } from '../Types';
import useModal from '../components/Modal/useModal';

const useOpenApiConfigs = () => {
    const navigate = useNavigate();
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const dispatch = useAppDispatch();
    const windowWidth = useAppSelector((state: RootState) => state.environment.windowWidth);
    const modal = useModal();
    const handleCreateNew = () => {
        navigate('/admin/openapiconfig/new');
    };

    const handleEdit = (config: OpenApiConfig) => {
        navigate(`/admin/openapiconfig/${config.identifier}`);
    };

    const handleDelete = useCallback(
        async (id: string) => {
            try {
                await openApiService.deleteConfig(id);
                dispatch(setListReloadType(PaginationListType.OpenApiConfigs));
                toast.success(i18n.translate({ id: 'config.delete.success', sourceName: 'OpenAPI' }));
            } catch (error) {
                console.error('Error deleting OpenAPI config:', error);
                toast.error(i18n.translate({ id: 'config.delete.error', sourceName: 'OpenAPI' }));
            }
        },
        [dispatch, i18n],
    );

    const handleOpenConfirmDialog = useCallback(
        (id: string, title: string) => {
            modal.deleteConfirm({
                title: i18n.translate({ id: 'config.delete.title', sourceName: 'OpenAPI' }),
                content: i18n.translate({
                    id: 'config.delete.text',
                    sourceName: 'OpenAPI',
                    params: {
                        title: title,
                    },
                }),
                onConfirm: () => handleDelete(id),
            });
        },
        [modal, i18n, handleDelete],
    );

    return {
        handleOpenConfirmDialog,
        i18n,
        windowWidth,
        handleEdit,
        handleCreateNew,
    };
};

export default useOpenApiConfigs;
